import(/* webpackMode: "eager" */ "/Users/karanbahadoer/TCGSecret/tcgsecret/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/karanbahadoer/TCGSecret/tcgsecret/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/karanbahadoer/TCGSecret/tcgsecret/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Localized"] */ "/Users/karanbahadoer/TCGSecret/tcgsecret/src/i18n/LocaleProvider.tsx");
